import { render, staticRenderFns } from "./replace.vue?vue&type=template&id=4eb2a7e9&scoped=true"
import script from "./replace.vue?vue&type=script&lang=js"
export * from "./replace.vue?vue&type=script&lang=js"
import style0 from "./replace.vue?vue&type=style&index=0&id=4eb2a7e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb2a7e9",
  null
  
)

export default component.exports